<template>
  <aside class="container mx-auto px-20 text-center relative z-10 pb-50">
    <div
      class="relative max-w-hero lg:max-w-reduced mx-auto -mt-[35px] lg:-mt-40"
    >
      <SpriteSymbol
        name="search"
        class="text-gray-500 text-md lg:text-2xl absolute top-1/2 left-20 lg:left-30 -translate-y-1/2 is-text-sized"
      />
      <input
        v-model.lazy="value"
        type="text"
        :placeholder="$texts('searchTextPlaceholder')"
        class="form-control block w-full pl-50 lg:pl-80 h-60 lg:h-80 text-md lg:text-lg font-normal text-gray-700 bg-white bg-clip-padding border-none shadow-lg rounded transition ease-in-out m-0 focus:text-gray-700 focus:outline focus:outline-2 focus:outline-green-alt"
      />
      <button
        v-if="value"
        class="absolute top-1/2 right-20 -translate-y-1/2"
        @click="value = ''"
      >
        <SpriteSymbol
          name="close"
          class="text-gray-500 text-md lg:text-xl is-text-sized"
        />
      </button>
    </div>
    <slot />
  </aside>
</template>

<script lang="ts" setup>
const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const value = computed<string>({
  get() {
    return props.modelValue
  },
  set(v: string) {
    emit('update:modelValue', v)
  },
})
</script>
